import _ from 'lodash';
/**
 * 存储格式, 统一JSON字符串
 * { data: Object | Array, t: timestamp }
 */
class NativeStorage {
    // constructor() {}
    static LOCAL_KEYS = {
        // STORE_SERVICE: 'STORE_SERVICE',
        CAR_NUM_CACHE: 'CAR_NUM_CACHE',
        COMPANY_CACHE: 'COMPANY_CACHE',
        STORE_GOODS_TEMP: 'STORE_GOODS_TEMP',
    };
    /**
     * 单位ms, 统一过期时间2小时
     */
    overTime = 2 * 3600 * 1000;
    time = (new Date()).getTime();
    initialized = false;
    init() {
        this.getTimeNow();
        this.initialized = true;
    }
    /**
     * 更新缓存内容及时间
     * 增加更新使用同样方法
     */
    update(key, val) {
        this.getTimeNow();
        localStorage.setItem(NativeStorage.LOCAL_KEYS[key], JSON.stringify({
            data: val,
            t: this.time
        }));
    }
    /**
     * 删除缓存
     */
    remove(key) {
        this.getTimeNow();
        localStorage.removeItem(NativeStorage.LOCAL_KEYS[key]);
    }
    /**
     * 检查时间是否过期
     */
    check(key) {
        // 数据初始化之后才加入检查, 否则没有数据

        this.getTimeNow();
        return new Promise((resolve, reject) => { // eslint-disable-line
            if (!this.initialized) {
                reject(null);
            }

            try {
                const storageKey = NativeStorage.LOCAL_KEYS[key];
                const storage = JSON.parse(localStorage.getItem(storageKey));

                if (storage.t < this.time - this.overTime) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            } catch (err) {
                reject(null);
            }
        });
    }
    /**
     * 获取
     */
    getLocal(key) {
        this.getTimeNow();
        return new Promise((resolve, reject) => {
            if (_.isEmpty(NativeStorage.LOCAL_KEYS[key])) reject({msg: 'The key is wrong'});

            try {
                const storage = JSON.parse(localStorage.getItem(NativeStorage.LOCAL_KEYS[key]));
                if (storage.t < this.time - this.overTime) {
                    resolve({});
                } else if (storage.data) {
                    resolve(storage.data);
                } else {
                    resolve({});
                }
            } catch (err) {
                resolve({});
            }
        });
    }
    // 最新时间
    getTimeNow() {
        this.time = (new Date()).getTime();
    }
}

export default NativeStorage;



// WEBPACK FOOTER //
// ./src/utils/storage.js